// created by zhayuechao on 2018-07-17;
import axios from "./http";

// 数组对象排序

function formateNamber(v1, v2, request) {
  if (typeof v1 === "string" && v1.indexOf("-") >= 0) {
    v1 = Number.parseFloat(v1.split("-").join(""));
    v2 = Number.parseFloat(String(v2).split("-").join(""));
  }
  if (
    (Number.isNaN(v1) && Number.isNaN(v2)) ||
    (typeof v1 === "string" && (v1.indexOf("%") || v1.indexOf("分")))
  ) {
    v1 = Number.parseFloat(v1);
    v2 = Number.parseFloat(v2);
  }
  // 升序
  if (request === "ascend") {
    if (v1 < v2) {
      return -1;
    } else if (v1 > v2) {
      return 1;
    } else {
      return 0;
    }
    // 降序
  } else if (request === "descend") {
    if (v1 > v2) {
      return -1;
    } else if (v1 < v2) {
      return 1;
    } else {
      return 0;
    }
  } else {
    console.log("排序参数为空");
  }
}

// 排列key: value
const sort = (name, request) => {
  return (data1, data2) => {
    let v1 = data1[name];
    let v2 = data2[name];
    // console.log(data1, data2)
    if (v1.length > 15) {
      v1 = v1.split("与")[0];
      v2 = v2.split("与")[0];
    }
    return formateNamber(v1, v2, request);
  };
};
//  柱状图带有排序
const sortTwoData = column => {
  // console.log(column)
  // 一个指标，或者为对比
  if (column.yaxislist.length === 1) {
    let first = column.yaxislist[0].value.map((item, i) => {
      return { a: item, b: column.xaxis[i] };
    });
    first.sort((a1, a2) => {
      return -(a1.a - a2.a);
    });
    column.yaxislist[0].value = first.map(item => {
      return item.a;
    });
    column.xaxis = first.map(item => {
      return item.b;
    });
    return column;
  } else {
    // 2个指标或者对比
    let first = column.yaxislist[0].value.map((item, i) => {
      return { a: item, b: column.xaxis[i], c: column.yaxislist[1].value[i] };
    });
    first.sort((a1, a2) => {
      return -(a1.a - a2.a);
    });
    column.yaxislist[0].value = first.map(item => {
      return item.a;
    });
    column.yaxislist[1].value = first.map(item => {
      return item.c;
    });
    column.xaxis = first.map(item => {
      return item.b;
    });
    return column;
  }
};
// 排列索引key
const sortData = (i, names, request, title) => {
  return (data1, data2) => {
    if (data1.name !== null && data2.name !== null) {
      if (
        data1.name.indexOf("汇总") === -1 &&
        data2.name.indexOf("汇总") === -1
      ) {
        if (i === 0) {
          if (title === "星期分布" || title === "时间分布") {
            let v1 = data1.dimensionID;
            let v2 = data2.dimensionID;
            return formateNamber(v1, v2, request);
          } else {
            let v1 = data1[names][i];
            let v2 = data2[names][i];
            return formateNamber(v1, v2, request);
          }
        } else {
          let v1 = data1[names][i];
          let v2 = data2[names][i];
          return formateNamber(v1, v2, request);
        }
      }
    }
  };
};

// 排列索引key  (对比时数据是数组时)
const sortCompareData = (i, names, request) => {
  return (data1, data2) => {
    // console.log(data1, data2)
    if (
      data1.name.indexOf("汇总") === -1 &&
      data2.name.indexOf("汇总") === -1
    ) {
      let v1 = data1[names][0][i];
      let v2 = data2[names][0][i];
      return formateNamber(v1, v2, request);
    }
  };
};

// 排列数据[{data: [1,2,3]}]
const sortObjectData = (i, names, request) => {
  return (data1, data2) => {
    // console.log(data1, data2)
    if (
      data1.name.indexOf("汇总") === -1 &&
      data2.name.indexOf("汇总") === -1
    ) {
      let v1 = Number.parseFloat(data1[names][i]);
      let v2 = Number.parseFloat(data2[names][i]);
      return formateNamber(v1, v2, request);
    }
  };
};

// [[1, 2], [2, 3]]
const sortDbArrayData = (i, request) => {
  return (data1, data2) => {
    let v1 = Number.parseFloat(data1[i]);
    let v2 = Number.parseFloat(data2[i]);
    return formateNamber(v1, v2, request);
  };
};

class Gradient {
  // 将hex表示方式转换为rgb表示方式(这里返回rgb数组模式)
  colorRgb(sColor) {
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var sColors = sColor.toLowerCase();
    if (sColors && reg.test(sColors)) {
      if (sColors.length === 4) {
        let sColorNew = "#";
        for (var i = 1; i < 4; i += 1) {
          sColorNew += sColors.slice(i, i + 1).concat(sColors.slice(i, i + 1));
        }
        sColors = sColorNew;
      }
      // 处理六位的颜色值
      var sColorChange = [];
      for (var j = 1; j < 7; j += 2) {
        sColorChange.push(parseInt("0x" + sColors.slice(j, j + 2)));
      }
      return sColorChange;
    } else {
      return sColors;
    }
  }
  // 将rgb表示方式转换为hex表示方式
  colorHex(rgb) {
    var _this = rgb;
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    if (/^(rgb|RGB)/.test(_this)) {
      var aColor = _this.replace(/(?:(|)|rgb|RGB)*/g, "").split(",");
      var strHex = "#";
      for (var i = 0; i < aColor.length; i++) {
        var hex = Number(aColor[i]).toString(16);
        hex = hex < 10 ? 0 + "" + hex : hex; // 保证每个rgb的值为2位
        if (hex === "0") {
          hex += hex;
        }
        strHex += hex;
      }
      if (strHex.length !== 7) {
        strHex = _this;
      }
      return strHex;
    } else if (reg.test(_this)) {
      var aNum = _this.replace(/#/, "").split("");
      if (aNum.length === 6) {
        return _this;
      } else if (aNum.length === 3) {
        var numHex = "#";
        for (let i = 0; i < aNum.length; i += 1) {
          numHex += aNum[i] + aNum[i];
        }
        return numHex;
      }
    } else {
      return _this;
    }
  }
}

const gradient = new Gradient();

class Queue {
  constructor() {
    this.list = [];
    this.num = 0; // 执行次数记录  防止多次监听造成的多次执行
  }
  add(fn, filter) {
    this.list.push({
      f: fn,
      params: filter
    });
  }
  size() {
    return this.list.length;
  }
  async done() {
    const self = this;
    let len = self.size();
    if (self.num === len) {
      // 如果执行次数等于事件数量
      //   self.num = 0 // 初始化执行次数
      //   self.list = []
    } else {
      await self.list[self.num]["f"](self.list[self.num]["params"]);
      self.num++;
    }
  }
}
var eQueue = new Queue();
// 数组排序
// 降序
// const arraySort = sort(function (val1, val2) {
//   return val1 - val2
// })

// 升序
// const arrayDesc = sort(function (val1, val2) {
//   return val2 - val1
// })
// console.log(o)

let source = {
  chart: [],
  index: [],
  table: [],
  pie: []
};

let addSource = keys => {
  source[keys].push(axios.CancelToken.source());
  if (source[keys].length >= 2) {
    source[keys][source[keys].length - 2].cancel();
  }
  return source[keys][source[keys].length - 1];
};

export {
  sort,
  sortData,
  sortCompareData,
  sortObjectData,
  sortDbArrayData,
  gradient,
  eQueue,
  addSource,
  sortTwoData
};
